'use client';

import type { ReactNode } from 'react';
import { usePathname } from 'next/navigation';
import { ScreenLayoutProvider } from '@/screen';
import { ScrollManagerProvider } from '@/contexts/ScrollManagerContext';
import { TabBarProvider } from '@/contexts/TabBarContext';
import { DesktopLayout } from '@/components/desktop/DesktopLayout';
import { SupportWidget } from '@/components/support/SupportWidget';
import { useIsDesktop } from '@/hooks/useIsDesktop';
import { DesktopContentWidthProvider } from '@/contexts/DesktopContentWidthContext';
import { stripLangPrefix } from '@/i18n/locale';

function isOnboardingPath(pathname: string): boolean {
  return pathname.startsWith('/onboarding');
}

export function ScreenPage({ children }: { children: ReactNode }) {
  const isDesktop = useIsDesktop();
  const pathname = usePathname();
  const minimal = isOnboardingPath(stripLangPrefix(pathname));

  const tree = (
    <ScrollManagerProvider>
      <TabBarProvider>
        <ScreenLayoutProvider>
          {children}
          <SupportWidget />
        </ScreenLayoutProvider>
      </TabBarProvider>
    </ScrollManagerProvider>
  );

  return (
    <DesktopContentWidthProvider>
      {isDesktop ? <DesktopLayout minimal={minimal}>{tree}</DesktopLayout> : tree}
    </DesktopContentWidthProvider>
  );
}
